import { useState } from 'react';
import { TabType } from '../../../../../types/ObjectBrowser/ComponentTypes';

export const useTabManagement = (tabs: TabType[]) => {
    const [activeTab, setActiveTab] = useState<"definition" | "statistics" | "insights">(tabs[0].value);

    const handleTabChange = (tabValue: "definition" | "statistics" | "insights") => {
        setActiveTab(tabValue);
    };

    return {
        activeTab,
        handleTabChange
    };
}; 